//Mainly for user to user messaging
const crypto = require('crypto');


class encrFile {
  constructor() {}

  encrypt(key, file) {
    var mykeyP = crypto.createCipher('aes-128-cbc', key);
    //console.log(file)
    var encFile = mykeyP.update(file, 'utf8', 'hex')
    encFile += mykeyP.final('hex');
    const fileObj = {encFile};
    const fileBlob = new Blob([JSON.stringify(fileObj, null, 2)], {type : 'application/json'});
    return fileBlob
  }

   decrypt(key, url) {
     return new Promise((resolve,reject)=>{
      fetch("https://cors-anywhere.herokuapp.com/" + url) // https://cors-anywhere.herokuapp.com/https://example.com
      .then(res => res.json())
      .then(json => {
        var mykeyU = crypto.createDecipher('aes-128-cbc', key);
        let file = mykeyU.update(json.encFile, 'hex', 'utf8')
        file += mykeyU.final('utf8');
        resolve(file)
      })
    })
  }
}
module.exports = encrFile
